import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Smartphone, Tag, Sparkles, CheckCircle2 } from "lucide-react";
import { useT } from "@/context/LangContext";

export default function RedeemDialog({ partner, open, onOpenChange }) {
  const { t } = useT();
  if (!partner) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg p-0 overflow-hidden rounded-2xl" data-testid={`redeem-dialog-${partner.id}`}>
        <DialogTitle className="sr-only">{t("redeem.title")}</DialogTitle>
        <DialogDescription className="sr-only">{t("redeem.tip")}</DialogDescription>
        <div className="relative bg-navy-900 text-white p-6 md:p-8">
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-lime-400/30 rounded-full blur-3xl pointer-events-none" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full bg-lime-500 text-navy-900 px-3 py-1 text-[11px] uppercase tracking-widest font-black mb-3">
              <Sparkles className="w-3.5 h-3.5" /> {partner.name}
            </div>
            <h3 className="font-heading font-black text-2xl md:text-3xl leading-tight">
              {t("redeem.title")}
            </h3>
            <div className="mt-3 text-lime-300 font-semibold text-sm md:text-base">{partner.offer}</div>
          </div>
        </div>
        <div className="p-6 md:p-8">
          <div className="text-xs uppercase tracking-widest text-navy-900/60 font-bold mb-4">
            {t("redeem.step_title")}
          </div>
          <ol className="space-y-3">
            <Step n={1} icon={Smartphone} text={t("redeem.step_1")} />
            <Step n={2} icon={Tag} text={t("redeem.step_2")} />
            <Step n={3} icon={CheckCircle2} text={t("redeem.step_3")} />
          </ol>
          <div className="mt-5 rounded-2xl bg-lime-500/15 border border-lime-500/30 p-4">
            <p className="text-sm text-navy-900 font-medium leading-relaxed">
              <span className="font-bold">💡 </span>
              {t("redeem.tip")}
            </p>
          </div>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="mt-6 w-full btn-navy text-sm"
            data-testid={`redeem-close-${partner.id}`}
          >
            {t("redeem.close")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function Step({ n, icon: Icon, text }) {
  return (
    <li className="flex items-start gap-3">
      <div className="shrink-0 w-9 h-9 rounded-xl bg-lime-500/15 flex items-center justify-center font-heading font-black text-navy-900 text-sm relative">
        <Icon className="w-4 h-4 text-navy-900" />
        <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-navy-900 text-lime-400 text-[10px] font-black flex items-center justify-center">
          {n}
        </span>
      </div>
      <p className="text-sm text-navy-900/80 leading-relaxed pt-1.5">{text}</p>
    </li>
  );
}
